import { useContext } from 'react';
import { FeaturesContext } from '@gtintel/platform-context';
import { convertCurrencySymbolToCode, formatPrice } from '@gtintel/platform-utils';
import { Price } from './styles';
export const ClientPrice = ({
  price,
  netPrice,
  currency,
  isPendingAnalysis
}) => {
  const isDiscounted = +netPrice !== +price;
  const featuresCtx = useContext(FeaturesContext);
  const displayDiscount = featuresCtx.discountedPriceDisplay === 'on' && isDiscounted;

  // Check if price is valid (not null, undefined, or NaN)
  const hasValidPrice = price != null && !isNaN(+price);
  const hasValidNetPrice = netPrice != null && !isNaN(+netPrice);
  return <Price className="content-tagtitle">
      {isPendingAnalysis ? <span>Pending Analysis</span> : hasValidPrice ? <>
          <span className={displayDiscount ? 'rate-card-price' : null}>
            {formatPrice(+price, convertCurrencySymbolToCode(currency))}
          </span>
          <br />
          {displayDiscount && hasValidNetPrice && <>{formatPrice(+netPrice, convertCurrencySymbolToCode(currency))}</>}
          <br />
          <span className="tax-note">
            (Excluding VAT or other applicable taxes)
          </span>
        </> : <span>-</span>}
    </Price>;
};